/**
 * ストアのページへのリンク。
 *
 * **公開日に App Store のURLを入れる**（App Store Connect の「App 情報」→「App Store で表示」で分かる。
 * 形は https://apps.apple.com/jp/app/id6818745375）。null のあいだは Web 版にボタンを出さない。
 * Google Play は Android 版を出すときに同じように入れる。
 */
export const APP_STORE_URL: string | null = null;
export const GOOGLE_PLAY_URL: string | null = null;

/** Web 版に出すストアのリンク（アプリの中では出さない。URL が未設定のものは出さない）。 */
export function storeLinksForWeb(isNative: boolean): Array<{ label: string; url: string; os: 'ios' | 'android' }> {
  if (isNative) return [];
  const links: Array<{ label: string; url: string; os: 'ios' | 'android' }> = [];
  if (APP_STORE_URL) links.push({ label: 'App Store で入手（iPhone）', url: APP_STORE_URL, os: 'ios' });
  if (GOOGLE_PLAY_URL) links.push({ label: '▶ Google Play で入手（Android）', url: GOOGLE_PLAY_URL, os: 'android' });
  return links;
}
